import {useSocket} from "socket.io-react-hook";

const useAuthSocket = () => {
  const token = sessionStorage.getItem('token');
  return useSocket(process.env.REACT_APP_SOCKET_URL!, {
    enabled: !!token,
    extraHeaders: {
      'Authorization': `Bearer ${token}`
    }
  })
}

export default useAuthSocket;